import React from "react";
import PageHeading from "../PageHeading";
import { MdOutlineUpload } from "react-icons/md";
import { useContext } from "react";
import ReportContext from "../../context/reportContext";
import RequestReportForm from "./RequestReportForm";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import ReportTabs from "./ReportTabs";

const Result = () => {
  const { t } = useTranslation();
  const reportContext = useContext(ReportContext);

  const handleModal = () => {
    reportContext.updateOpenModal(true);
  };
  return (
    <>
      <ToastContainer />
      <div className='reports-section'>
        <PageHeading
          pageTitle={t("reports")}
          icon={<MdOutlineUpload />}
          pageModalTitle={t("requestNewReport")}
          pageModalOpen={handleModal}
        />

        <RequestReportForm
          isOpen={reportContext.isOpenModal}
          isAddMode={reportContext.isAddMode}
        />
        <div className='reports-table-wrapper mt-5'>
          {/* <ReportsData /> */}
          <ReportTabs />
        </div>
      </div>
    </>
  );
};

export default Result;
